import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label } from "reactstrap";

const EditModal = ({
    isOpen,
    toggle,
    title,
    content,
    setContent,
    imageFile,
    setImageFile,
    imagePreview,
    employeeName,
    setEmployeeName,
    employeeRole,
    setEmployeeRole, eventDate, setEventDate
}) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>{title}</ModalHeader>

            <ModalBody>
                {setEmployeeName && setEmployeeRole && (
                    <>
                        <label className="form-label">Employee Name</label>
                        <input
                            type="text"
                            className="form-control mb-2"
                            value={employeeName}
                            onChange={(e) => setEmployeeName(e.target.value)}
                        />

                        <label className="form-label">Employee Role</label>
                        <input
                            type="text"
                            className="form-control mb-3"
                            value={employeeRole}
                            onChange={(e) => setEmployeeRole(e.target.value)}
                        />
                    </>
                )}
                {setEventDate && (
                    <>
                        <label className="form-label">Event Date</label>
                        <input
                            type="date"
                            className="form-control mb-3"
                            value={eventDate}
                            onChange={(e) => setEventDate(e.target.value)}
                        />
                    </>
                )}

                <Label className="fw-bold">Description</Label>
                <Input
                    type="textarea"
                    rows="4"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    className="mb-3"
                    style={{ borderRadius: "10px" }}
                />

                <Label className="fw-bold">Upload Image</Label>
                <Input
                    type="file"
                    accept="image/*"
                    className="mb-2"
                    onChange={(e) => setImageFile(e.target.files[0])}
                />

                {imagePreview && (
                    <img
                        src={imagePreview}
                        alt="Preview"
                        style={{
                            width: "100%",
                            maxHeight: "200px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            marginTop: "10px"
                        }}
                    />
                )}
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="primary" onClick={() => toggle("save")}>Save</Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditModal;
